<template lang="pug">
.container.grid-lg.py-2
  form-filter
  .text-right.my-2
    router-link.btn.btn-primary(:to="{name: 'app.sistema.ausentes.add'}")
      btn-content(name="new")
  load-manager(:status='status')
    list-manager(:status='status', :count='list.length')
      table.table.table-striped.table-hover.table-sm
        thead
          tr
            th {{ 'ausente.ausente' | tModel }}
            th {{ 'ausente.substituto' | tModel }}
            th {{ 'ausente.tipo' | tModel }}
            th {{ 'ausente.inicia_em' | tModel }}
            th {{ 'ausente.termina_em' | tModel }}
            th.text-right(width="1") Ações
        tbody
          tr(v-for="ausente in list" :key="ausente.id")
            td {{ ausente.ausente.nome }}
            td {{ ausente.substituto.nome }}
            td {{ `enums.db.enum_ausente_tipo.${ausente.tipo}` | translate }}
            td {{ ausente.inicia_em | date('DD/MM/YYYY') }}
            td {{ ausente.termina_em | date('DD/MM/YYYY') }}
            td.text-right
              router-link(:to="{ name: 'app.sistema.ausentes.edit', params: { id: ausente.id } }")
                btn-icon(name='edit')
      .my-2.text-right(v-if='pages > 1')
        btn-paginate(:page='page', :pages='pages', :count='count', @go-page='goPage', @prev-page='prevPage', @next-page='nextPage')
  router-view
</template>

<script>
import list, { vuexDefaultMapping } from '@/mixins/list'
import FormFilter from './Filter.vue'

export default {
  vuex: {
    'sistema/ausentes': vuexDefaultMapping,
  },
  components: { FormFilter },
  mixins: [list],
  created() {
    this.search()
  },
}
</script>
